import { grey } from "@mui/material/colors";

const styles = {
  root: (isMediumScreen: boolean) => ({
    left: isMediumScreen ? 0 : "15vw",
    bottom: 0,
    top: 0,
    right: 0,
    width: isMediumScreen ? "auto" : "calc(100% - 15vw)",
    position: "absolute",
    overflow: "hidden",
  }),
  mobileRoot: {
    position: "absolute",
  },
  sidebarContainer: {
    borderRight: `1px solid ${grey[200]}`,
    borderLeft: `1px solid ${grey[200]}`,
  },
  mainThreadContainer: {
    position: "relative",
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
  },
};

export default styles;
